import BossModel from "@/models/BossModel";

export default class UniqueSellingPoint extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/unique-selling-point';

    /**
     *
     * @type {string}
     */
    static entity = 'productUniqueSellingPoints';

    static fields() {
        return {
            id: this.attr(null),
            sort_order: this.attr(null),
            text: this.attr(null),
            product_id: this.attr(null),
            // product: Product,
        }
    }
}
